// @mui
import {
  Button,
  Divider,
  FormControlLabel,
  Input,
  MenuItem,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
// routes

// _mock_
// components
import Scrollbar from "../../../components/scrollbar";
import {
  TableEmptyRows,
  TableHeadCustom,
  TableNoData,
  useTable,
} from "../../../components/table";
// sections
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { ViewGuard } from "src/auth/MyAuthGuard";
import { getLoggedInUser } from "src/auth/utils";
import ConfirmDialog from "src/components/confirm-dialog/ConfirmDialog";
import Iconify from "src/components/iconify/Iconify";
import TableBodySkeleton from "src/components/table/TableBodySkeleton";
import LearningPlanController from "src/controller/LearningPlan.controller";
import StudentController from "src/controller/Student.controller";
import { useProgram } from "src/hooks/useProgram";
import AddTopicDialog from "src/pages/student/Learning/AddTopicDialog";
import StudentTabContainer from "../sections/StudentTabContainer.section";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "q.no", label: "Q.No", align: "left" },
  { id: "topic", label: "Topic", align: "left" },
  { id: "subTopic", label: "Sub Topic", align: "left" },
  // { id: "learningMaterial", label: "Learning Material", align: "left" },
  { id: "currentScore", label: "Initial Score", align: "left" },
  { id: "startDate", label: "Start Date", align: "left" },
  { id: "endDate", label: "End Date", align: "left" },
  { id: "hoursAttended", label: "Hours planned", align: "center" },
  { id: "taken", label: "Hours Used", align: "center" },
];

// ----------------------------------------------------------------------
let LearningPlans = null;
let Questions = {};

export default function LearningPage({
  enrollments,
  student,
  readOnly = false,
}) {
  const { dense, order, orderBy, selected, onSort } = useTable();

  const params = useParams();
  const [tableData, setTableData] = useState([]);
  const [learningPlan, setLearningPlan] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [learningPlanEnabled, setLearningPlanEnabled] = useState(false);
  const [topicOpen, setTopicOpen] = useState(false);
  const [topicFormData, setTopicFormData] = useState();
  const [startDate, setStartDate] = useState(null);
  const [id, setId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const reset = () => {
    setLearningPlan(null);
    setTableData([]);
    setLearningPlanEnabled(false);
  };

  const { program, handleProgramChange } = useProgram(id, reset);

  function handleOnSave() {
    let payload = { ...learningPlan };
    payload.enabled = learningPlanEnabled;

    let paylaodQuestions = [];

    tableData.forEach((item, index) => {
      let data = Questions[item._id];
      if (data) {
        item = { ...item, ...data };
      }
      paylaodQuestions.push(item);
    });

    payload.questions = paylaodQuestions;

    LearningPlanController.update(payload.id, payload)
      .then((res) => {
        window.Toast("Learning planed saved");
        setTableData(payload.questions);
      })
      .catch((err) => {
        console.error(`Api Error: ${err.message}`);
      });
  }

  function fetchLearningPlan() {
    setIsLoading(true);

    try {
      setLearningPlan([]);
      setTableData([]);
      setLearningPlanEnabled(false);
    } catch (err) {
      console.log(err);
    }

    StudentController.getLearningPlans(id)
      .then((res) => {
        LearningPlans = res;

        let temp = LearningPlans?.filter((i) => i.subject_code === program);
        if (temp?.length === 1) {
          setLearningPlan(temp[0]);
          setTableData(temp[0].questions);
          setLearningPlanEnabled(temp[0].enabled);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => setIsLoading(false), 1);
      });
  }

  const handleTopicOpen = () => {
    setTopicFormData();
    setTopicOpen(true);
  };

  const handleTopicClose = () => {
    setIsLoading(true);
    setTopicOpen(false);
    setTopicFormData();
    fetchLearningPlan();
  };

  function handleCopyPublicLink() {
    const data = {
      program_code: program,
      student_id: id,
      student_name:
        student.first_name || student.last_name
          ? student.first_name + " " + student.last_name
          : null,
    };
    LearningPlanController.getPublicLink(data)
      .then((res) => {
        navigator.clipboard.writeText(res.url);
        window.Toast("Public link copied for Learning Plan");
      })
      .catch((err) => {
        window.ToastError("Failed to copy public link.");
      });
  }

  useEffect(() => {
    fetchLearningPlan();
  }, [id, program]);

  useEffect(() => {
    let temp = LearningPlans?.filter((i) => i.subject_code === program);
    if (temp?.length === 1) {
      setLearningPlan(temp[0]);
      setTableData(temp[0].questions);
      setLearningPlanEnabled(temp[0].enabled);
      setIsLoading(true);
      setTimeout(() => setIsLoading(false), 1);
    }
  }, [program]);

  function updateValue(data) {
    let temp = { ...Questions };
    let value = {
      start_date: null,
      end_date: null,
      duration: "",
      taken: "",
      ...(temp[data.id] ?? {}),
    };

    if (data.start_date) {
      value.start_date = data.start_date || null;
      setStartDate(data.start_date);
    }

    if (data.end_date) {
      value.end_date = data.end_date || null;
    }

    if (data.duration) {
      value.duration = data.duration;
    }

    if (data.taken) {
      value.taken = data.taken;
    }

    temp[data.id] = value;
    Questions = temp;
  }

  function is_show(data) {
    if (data === undefined || data === null || data === "") return false;
    return true;
  }

  useEffect(() => {
    const user = getLoggedInUser();
    if (user.role === "student") {
      setId(user.student_id);
    } else {
      setId(params.id);
    }
  }, []);

  function handleDeleteLearningPlan() {
    setDeleteDialogOpen(true);
  }

  function handleCloseDeleteDialog() {
    setDeleteDialogOpen(false);
  }

  function confirmDeleteLearningPlan() {
    if (!learningPlan?.id) return;

    LearningPlanController.delete(learningPlan.id)
      .then((res) => {
        window.Toast("Learning plan deleted");
        setDeleteDialogOpen(false);
        fetchLearningPlan();
      })
      .catch((err) => {
        console.log(err);
        setDeleteDialogOpen(false);
      });
  }

  return (
    <StudentTabContainer
      title="Learning Plan"
      content={
        <Stack
          spacing={2}
          display="flex"
          justifyContent="space-between"
          direction="row"
        >
          {learningPlan && !readOnly && (
            <Button Button variant="contained" onClick={handleOnSave}>
              Save
            </Button>
          )}
        </Stack>
      }
    >
      <Stack
        sx={{ mt: 2, mb: 2 }}
        fullWidth
        display="flex"
        justifyContent="space-between"
        direction="row"
      >
        <TextField
          fullWidth
          select
          label="Program"
          size="small"
          value={program}
          onChange={(event) => handleProgramChange(event.target.value)}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: {
                  maxHeight: 260,
                },
              },
            },
          }}
          sx={{
            maxWidth: { sm: 340 },
            textTransform: "capitalize",
          }}
        >
          {enrollments
            ?.reduce((acc, curr) => {
              if (
                curr.program_name &&
                curr.program_name.trim() !== "" &&
                !acc.includes(curr.program_name)
              ) {
                acc.push(curr.program_name);
              }
              return acc;
            }, [])
            .map((programName) => (
              <MenuItem
                key={programName}
                value={programName}
                sx={{
                  mx: 1,
                  borderRadius: 0.75,
                  typography: "body2",
                  textTransform: "capitalize",
                }}
              >
                {programName}
              </MenuItem>
            ))}
        </TextField>

        {learningPlan && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            {tableData?.length && (
              <FormControlLabel
                control={
                  <Switch checked={learningPlanEnabled} disabled={readOnly} />
                }
                onChange={() => {
                  if (readOnly) return;
                  setLearningPlanEnabled((pre) => !pre);
                }}
                label="Enable Learning Plans"
              />
            )}
            {!readOnly && (
              <Button
                variant="contained"
                size="small"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={handleTopicOpen}
              >
                Topic
              </Button>
            )}

            <ViewGuard
              orPermissions={["home.learningPlan.delete"]}
              condition={learningPlan?.id ?? null}
            >
              <Button
                size="small"
                variant="contained"
                startIcon={<Iconify icon="material-symbols:delete-outline" />}
                color="error"
                onClick={handleDeleteLearningPlan}
              >
                Delete
              </Button>
            </ViewGuard>
          </Stack>
        )}
      </Stack>

      <TableContainer sx={{ position: "relative", overflow: "unset", mt: 2 }}>
        <Scrollbar>
          <Table size={dense ? "small" : "medium"} sx={{ minWidth: 800 }}>
            <TableHeadCustom
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={tableData?.length}
              numSelected={selected?.length}
              onSort={onSort}
            />

            <TableBody>
              {!isLoading &&
                (readOnly
                  ? tableData?.filter((r) => r?.duration && r.duration !== "0")
                  : tableData
                )
                  ?.sort((a, b) => {
                    if (a.topic < b.topic) return -1;
                    if (a.topic > b.topic) return 1;
                    if (a.sub_topic < b.sub_topic) return -1;
                    if (a.sub_topic > b.sub_topic) return 1;
                    return 0;
                  })
                  .map((row, index) => {
                    return (
                      <TableRow hover key={index}>
                        <TableCell align="left">{index + 1}</TableCell>
                        <TableCell align="left">{row.topic ?? "-"} </TableCell>
                        <TableCell align="left" sx={{ maxWidth: "300px" }}>
                          {row.sub_topic ?? "-"}
                        </TableCell>
                        <TableCell align="left">{row.score ?? "-"}</TableCell>
                        <TableCell align="left">
                          {/* Start Date: show value; if empty and readOnly, show '-' else input */}
                          {is_show(row.start_date) ? (
                            row.start_date
                          ) : readOnly ? (
                            "-"
                          ) : (
                            <Input
                              type="date"
                              size="small"
                              disabled={
                                !is_show(row.start_date) && !learningPlanEnabled
                              }
                              defaultValue={row?.start_date ?? ""}
                              onChange={(e) => {
                                const value = e.target.value || null;
                                updateValue({
                                  id: row._id,
                                  start_date: value,
                                });
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {/* End Date: show value; if empty and readOnly, show '-' else input */}
                          {row.end_date ? (
                            row.end_date
                          ) : readOnly ? (
                            "-"
                          ) : (
                            <Input
                              type="date"
                              size="small"
                              disabled={
                                !is_show(row.end_date) && !learningPlanEnabled
                              }
                              defaultValue={row?.end_date ?? ""}
                              onChange={(e) => {
                                const value = e.target.value || null;
                                updateValue({
                                  id: row._id,
                                  end_date: value,
                                });
                              }}
                              inputProps={{
                                min: startDate || "1900-01-01",
                              }}
                            />
                          )}
                        </TableCell>

                        <TableCell align="center">
                          {row.duration && row.duration !== "0" ? (
                            <span>{row.duration ?? ""}</span>
                          ) : (
                            <select
                              style={{
                                padding: "5px 10px",
                                borderColor: "transparent",
                                borderBottom: "2px solid #000",
                                backgroundColor: "transparent",
                              }}
                              disabled={
                                !learningPlanEnabled && !is_show(row.duration)
                              }
                              defaultValue={row.duration ?? ""}
                              onChange={(e) => {
                                e.preventDefault();

                                const selectedValue = e.target.value;
                                updateValue({
                                  id: row._id,
                                  duration: selectedValue,
                                });
                              }}
                            >
                              <option>Hours</option>
                              <option value="0">0 h</option>
                              <option value="15m">15 m</option>
                              <option value="30m">30 m</option>
                              {[...Array(20)].map((_, index) => (
                                <option
                                  key={`${index + 1}h`}
                                  value={`${index + 1}h`}
                                >
                                  {index + 1} h
                                </option>
                              ))}
                            </select>
                          )}
                        </TableCell>

                        <TableCell align="center">
                          <select
                            style={{
                              padding: "5px 10px",
                              borderColor: "transparent",
                              borderBottom: "2px solid #000",
                              backgroundColor: "transparent",
                            }}
                            defaultValue={row.taken ?? ""}
                            disabled={!learningPlanEnabled || readOnly}
                            onChange={(e) => {
                              e.preventDefault();

                              updateValue({
                                id: row._id,
                                taken: e.target.value,
                              });
                            }}
                          >
                            <option>Hours</option>
                            <option value="15m">15 m</option>
                            <option value="30m">30 m</option>
                            {[...Array(20)].map((i, index) => (
                              <option
                                key={`${index + 1}h`}
                                value={`${index + 1}h`}
                              >
                                {index + 1} h
                              </option>
                            ))}
                          </select>
                        </TableCell>
                      </TableRow>
                    );
                  })}

              <TableEmptyRows
                emptyRows={tableData?.length === 0 && !isLoading}
              />

              {isLoading && (
                <TableBodySkeleton rows={10} columns={TABLE_HEAD.length} />
              )}

              <TableNoData isNotFound={!isLoading && tableData?.length === 0} />
            </TableBody>
          </Table>
        </Scrollbar>
      </TableContainer>
      <AddTopicDialog
        open={topicOpen}
        data={topicFormData}
        onClose={handleTopicClose}
        learningPlan={learningPlan}
      />
      <ConfirmDialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        title="Delete Learning Plan"
        content={
          <>
            Are you sure you want to delete this learning plan?
            <br />
            <strong>Warning: Once deleted, it cannot be recovered.</strong>
          </>
        }
        action={
          <Button
            variant="contained"
            color="error"
            onClick={confirmDeleteLearningPlan}
          >
            Delete
          </Button>
        }
      />
    </StudentTabContainer>
  );
}
